import React from "react";
import styles from "../Dashboard.module.css";

const JournalFinder = () => {
  return (
    <div className={styles.dashboard}>
      <main className={styles.main}>Journal Finder</main>
    </div>
  );
};

export default JournalFinder;
